//include 9
jQuery(function(){

    var overlayClass = 'overlaykarte';

    var mapUrl = window.pixelpoint.domainService.get("mapUrl");

    if(window.location.host == 'localhost:3000'){
       // mapUrl += "testLocal/";
        //mapUrl = 'https://localhost:3003/';
        //mapUrl = 'https://maps.reiseland-brandenburg.de/testLocal/';
    }

    //var mapUrl = 'https://maps.reiseland-brandenburg.de/test.html'; 
    var links = {
        'default': `${mapUrl}`,
        'location': `${mapUrl}#/?location=%id%`,
        'region': `${mapUrl}#/?region=region:%id%`,
        'excursion': {
            'default': `${mapUrl}#/excursion`,
            'add': `${mapUrl}#/excursion?id=%id%`,
            'location': `${mapUrl}#/excursion?location=%id%`,
            'region': `${mapUrl}#/excursion?region=region:%id%`,
            'aquaticsdistrict':`${mapUrl}#/excursion?region=aquaticsdistrict:%id%`,
            'nationallandscapes':`${mapUrl}#/excursion?region=nationallandscapes:%id%`,
            'excursions':`${mapUrl}#/excursion?region=excursions:%id%`,
        },
        'directions': {
            'default':`${mapUrl}#/excursion?route_locate=true&route_%type%=%id%&route_type=%transport%&supress_explanation=1`,
            'defaulttarget':`${mapUrl}#/excursion?route_locate=true&route_target=%target%&route_type=%transport%&supress_explanation=1`,
            'address':`${mapUrl}#/excursion?route_address=%address%&route_%type%=%id%&route_type=%transport%&supress_explanation=1`,
            'addresses':`${mapUrl}#/excursion?route_address=%address%&route_target=%target%&route_type=%transport%&supress_explanation=1`
        }
    };

    var lityInstance = null;
    var dataPrependString = "mapProperty";

    var privateFunctions = {
        parse(type, attributes) {
            var link = type.split('.').reduce((o, i) => o[i], links);
            return link.replace(/%\w+%/g, function (all) {
                var key = all.replace(/%/g, '');
                return attributes[key] || all;
            });
        },
        close() {
            if (lityInstance != null) {
                lityInstance.close();
                lityInstance = null;
            }
        },
        open(type, attributes) {
            type = type || "";
            attributes = attributes || {};
            var link = this.parse(type, attributes);
            if (!link)
                return;

            var urlParameters = {};
            if(!readCookie("pp_allow_third_party_cookies")){
                urlParameters.pp_allow_thirdparty_cookies = 1;
            }
            if(!readCookie("pp_allow_analytics_cookies")){
                urlParameters.pp_allow_analytics_cookies = 1;
            }
            link = window.pixelpoint.utilities.addUrlParameters(link, urlParameters);

            this.close();
            lityInstance = lity(`<div class="lity-iframe-container" style="max-height: 100vh"><iframe frameborder="0" allowfullscreen="" src="${link}" allow="geolocation *"></iframe></div>`);//lity(link);
            lityInstance.element().removeClass("lity-inline").addClass("lity-iframe").addClass(overlayClass);
            //lityInstance.element().find("iframe").attr("allow",'geolocation *');
            //lityInstance.element().find("iframe").contentWindow.location.reload();
        },
        openInNewTab(type, attributes){
            type = type || "";
            attributes = attributes || {};
            var link = this.parse(type, attributes);
            if (!link)
                return;
            this.close();
            window.open(link,'_blank');
        }
    };

    $("[data-open-map]").click(function(e){
        var type = $(this).data('open-map') || null;

        if(!type){
            e.preventDefault();
            return;
        }

        var attributes = {};
        var storedData = $(this).data();
        for (var key in storedData) {
            if (storedData.hasOwnProperty(key)) { //important, so we do not access the prototype. Do not access the prototype here or bad thinks will happen!

                if (key.indexOf(dataPrependString) == 0) {
                    var propertyName = key.replace(dataPrependString, "");
                    if (!!propertyName) {
                        propertyName = propertyName.charAt(0).toLowerCase() + propertyName.slice(1);
                        attributes[propertyName] = storedData[key];
                    }
                }

            }
        }

            var regions = [
                {id: 2, linkDe: "/orte-regionen/urlaubsregionen/spreewald/", linkEn: ""},
                {id: 3, linkDe: "/orte-regionen/urlaubsregionen/prignitz/", linkEn: ""},
                {id: 4, linkDe: "/orte-regionen/urlaubsregionen/ruppiner-seenland/", linkEn: ""},
                {id: 5, linkDe: "/orte-regionen/urlaubsregionen/potsdam/", linkEn: ""},
                {id: 6, linkDe: "/orte-regionen/urlaubsregionen/lausitzer-seenland/", linkEn: ""},
                {id: 7, linkDe: "/orte-regionen/urlaubsregionen/seenland-oder-spree/", linkEn: ""},
                {id: 10, linkDe: "/orte-regionen/urlaubsregionen/barnimer-land/", linkEn: ""},
                {id: 11, linkDe: "/orte-regionen/urlaubsregionen/dahme-seenland/", linkEn: ""},
                {id: 12, linkDe: "/orte-regionen/urlaubsregionen/flaeming/", linkEn: ""},
                {id: 13, linkDe: "/orte-regionen/urlaubsregionen/havelland/", linkEn: ""},
                {id: 14, linkDe: "/orte-regionen/urlaubsregionen/elbe-elster-land/", linkEn: ""},
                {id: 16, linkDe: "/orte-regionen/urlaubsregionen/uckermark/", linkEn: ""},
            ];

        var regionId = attributes.id;
        var region = regions.filter(function (r) { return r.id == regionId });

        var langObject = $("[data-language-obj]").data("language-obj");
        var languageKey = "linkDe";
        if(!!langObject && !!langObject.id == 1){
            languageKey = "linkEn";
        }

        var link = '';
        if(region.length == 1){
            link = region[0][languageKey];
        }

        // triggers are buttons or divs as well, so never rely on an anchor's default navigation
        e.preventDefault();
        var executeDefault = function(){
            if (!window.pixelpoint.isMobile.any()) {
                privateFunctions.open(type,attributes);
            }
            else{
                privateFunctions.openInNewTab(type,attributes);
            }
        };
        var ignoreRegionLinks = $(this).is('[data-ignore-region-links]');
        if(!!link && !ignoreRegionLinks){
            $.ajax({
                url: link,
                type:'HEAD',
                success: function()
                {
                    window.open(link,'_blank');
                },
                error: executeDefault,
                async: false
            });
        }
        else {
            executeDefault();
        }
    });


    window.pixelpoint.map = {
        open(type, attrs) {
            //25.01.2021 - from now on we open the map every time in a new tab
            privateFunctions.openInNewTab(type, attrs);
            /*
            if (window.pixelpoint.isMobile.any()) {
                privateFunctions.openInNewTab(type, attrs);
            } else {
                privateFunctions.open(type, attrs);
            }
            //*/
        },
        close() {
            privateFunctions.close();
        },
        root() {
            return mapUrl;
        },
        getLink(type, attrs){
            type = type || "";
            attrs = attrs || {};
            var link = privateFunctions.parse(type, attrs);
            if (!link)
                return '';
            return link;
        }
    };

    //hack for the global map
    $('.controls .icon-map-2-after').click(function(e){
        if(!!$('.controls .icon-map-2-after').tooltipster){
            $('.controls .icon-map-2-after').tooltipster('close');
        }
    });
    // ----------------------

});